export default "__VITE_ASSET__hjh0DXAl__"